import { Edit } from '@mui/icons-material';
import { Alert, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { editProduct } from '../../../api/products';
import useAuthToken from '../../../hooks/getUserData';
import Modal from '../../elements/Modal';
import ProductComparisonForm from './ProductComparisonForm';

export default function EditProductComparison({
  product,
  fetchData,
  setMessage,
  setSnackbarOpen,
}) {
  const [open, setOpen] = useState(false);
  const [productData, setProductData] = useState({});
  const [error, setError] = useState(null);

  const token = useAuthToken();

  useEffect(() => {
    setProductData({ ...product });
  }, [product]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  const handleEditForm = async (values) => {
    const payload = {
      ...values,
    };
    try {
      const response = await editProduct(payload, product.id, token);
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      setSnackbarOpen(true);
      setMessage('Product updated successfully');
      fetchData();
      handleClose();
    } catch (error) {
      setError(
        error.message || 'An error occurred while updating product data.'
      );
    }
  };

  return (
    <>
      <IconButton variant="text" onClick={handleClickOpen}>
        <Edit />
      </IconButton>
      <Modal
        open={open}
        width={'sm'}
        modalTitle="Edit Comparison details"
        handleClose={handleClose}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <ProductComparisonForm
          product={productData}
          onSubmit={handleEditForm}
        />
      </Modal>
    </>
  );
}
